
let initialState = {
    api: ''
};

const CIReducer = (state = initialState, action) => {
    return state;
}

export default CIReducer;